<template>
  <vx-card id="taskViewDataContainer" class="vs-con-loading__container">
    <div class="vx-row">
      <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
        <div class="mb-4">
          <h5>{{ $tc('detail', 2) }}</h5>
          <hr>
        </div>

        <div>
          <label>{{ $t('business_title') }}:</label>
          &nbsp;
          <strong v-text="task.name"></strong>
        </div>

        <div>
          <label>{{ $t('assigned_person_in_charge') }}:</label>
          &nbsp;
          <div>
            <ul>
              <li v-for="(user, key) in task.assigned_to" :key="key">
                <span v-text="user.username"></span>
              </li>
            </ul>
          </div>
        </div>

        <div>
          <label>{{ $t('category') }}:</label>
          &nbsp;
          <strong v-text="task.task_category_name"></strong>
        </div>

        <div>
          <label>{{ $t('deadline') }}:</label>
          &nbsp;
          <strong v-text="task.due_date"></strong>
        </div>

        <div class="mt-4 mb-4">
          <h5>{{ $t('additional_information') }}</h5>
          <hr>
        </div>

        <div>
          <label>{{ $t('start_date') }}:</label>&nbsp;<strong v-text="task.start_date"></strong>
        </div>

        <div>
          <label>{{ $t('reminder_date') }}:</label>&nbsp;<strong v-text="task.reminder_date"></strong>
        </div>

        <div>
          <label>{{ $t('progress') }}:</label>&nbsp;<strong v-text="`${task.progress}%`"></strong>
        </div>

        <div>
          <label>{{ $t('priority') }}:</label>&nbsp;<strong v-text="task.priority_name"></strong>
        </div>

        <div>
          <label>{{ $t('progress_status') }}:</label>&nbsp;<strong v-text="task.progress_status_name"></strong>
        </div>

        <div v-if="task.link != null">
          <label>{{ $tc('link', 3) }}:</label>&nbsp;<span v-text="task.link.url"></span>
        </div>

        <div>
          <label>{{ $t('visibility') }}:</label>&nbsp;<strong v-text="task.visibility"></strong>
        </div>

        <div>
          <label>{{ $t('business_definition') }}:</label>
          <div class="kt-bg-outline-light p-3">
            <span v-text="task.description"></span>
          </div>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import {EventBus} from '@/../eventbus'
import Task from '@/models/Task'

export default {
  name: 'Shared.Tasks.View',
  data () {
    return {
      task: {},
      visibilityOptions: []
    }
  },
  mounted () {
    // TODO: Check why this is mounting twice.
    EventBus.$on('initViewTaskModal', (data) => {
      this.viewTask(data.id)
    })
  },
  methods: {
    async viewTask (id) {
      try {
        const response = await Task.view({ id })
        this.visibilityOptions = response.data.meta.options.visibilities
        this.task = response.data.data

        // TODO: Find a better alternative
        this.task.priority_name = this.$t(this.task.priority_name.toLowerCase())
        this.task.progress_status_name = this.$t(this.task.progress_status_name.replace(' ', '_').toLowerCase())
        this.task.visibility = this.$t(this.task.visibility_name.toLowerCase())
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
